export default __webpack_public_path__ + "static/media/google-play.f892cc5d.png";